import moment from "moment";
import "moment/locale/hr";

export function getCurrentTime() {
  var dateTime = new Date();
  var momentHr = moment(dateTime);
  momentHr.locale("hr");
  return momentHr.format("HH:mm:ss");
}

export function getTimeMinutes(time: any) {
  var splitedTime = time.split(":");
  return splitedTime[0] * 60 + splitedTime[1] * 1;
}

export function isCurrentTimeBetweenTwoTimes(timeOne: string, timeTwo: string) {
  var currentMinutes = getTimeMinutes(getCurrentTime());
  var timeOneMinutes = getTimeMinutes(timeOne) - 1;
  var timeTwoMinues = getTimeMinutes(timeTwo);

  if (timeTwo < timeOne) {
    timeTwoMinues += (24 * 60)
  }

  if (timeOneMinutes < currentMinutes && currentMinutes < timeTwoMinues) {
    return true;
  } else {
    return false;
  }
}

export function convertDateToUtc(date: string) {
  return moment.utc(moment(date)).format()
    .replace('T', ' ')
    .replace('Z', '');
}

export function formatDateTime(date: Date) {
  var dateAsString = date.toString();

  if (!dateAsString.endsWith('Z')) {
    dateAsString = `${date}Z`;
  }

  var dateTime = new Date(dateAsString);
  var momentHr = moment(dateTime);
  momentHr.locale("hr");
  return `${momentHr.format("L")} ${momentHr.format("LTS")}`;
}